module.exports = __webpack_public_path__ + "static/media/Handletteredawardsign2019Enamelonpanel.d8f2e70b.webp";